export const SET_LOGGED_IN_STATUS = 'SET_LOGGED_IN_STATUS';
export const SHOW_SHORTENED_FORM = 'SHOW_SHORTENED_FORM';
export const SHOW_FULL_FORM = 'SHOW_FULL_FORM';



// WEBPACK FOOTER //
// ./src/constants/actions.js